import React, {useMemo, useContext} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {useMediaQuery} from "react-responsive";
import "whatwg-fetch";
import {pluralize} from "../../../../utils/pluralize";
import {CartList} from "../CartList";
import {Context} from "../../index";

import styles from "./cart-content.module.scss";
import CloseIcon from "../../../common/Icons/CloseIcon";
import IconButton from "@material-ui/core/IconButton";

export function CartContent({items, close}) {
  const isMobile = useMediaQuery({maxWidth: 940});
  const {onPlatform} = useContext(Context);

  const totalAmount = useMemo(
    () => `${items.length} ${pluralize(items.length, `вещь`, `вещи`, `вещей`)}`,
    [items.length]
  );
  const totalPrice = useMemo(
    () =>
      items.reduce((accumulator, current) => accumulator + current.price, 0),
    [items]
  );
  const itemsElements =
    items.length > 0 ? (
      <CartList items={items} />
    ) : (
      <div className={styles.empty}>Корзина пуста</div>
    );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <div>В корзине {totalAmount}</div>
          <div>на {totalPrice} ₽</div>
        </div>
        {isMobile && (
          <IconButton
            onClick={close}
            className={styles.closeButton}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>
      <div className={styles.list}>{itemsElements}</div>
      <div
        className={classnames(styles.checkout, {
          [styles.checkoutVTB]: onPlatform === `vtb`
        })}
      >
        <a href="/cart">Оформить заказ</a>
      </div>
    </div>
  );
}

CartContent.propTypes = {
  close: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.string,
      price: PropTypes.number,
      amount: PropTypes.number,
      picture: PropTypes.string
    })
  )
};
